import { page_builder_origin } from "features/PageBuilders/PageBuilders.constants";

export const GJS_THANKYOU_BUILDER_ROUTE_KEYS = {
  update: "gjs-thankyou-builder-update",
};

export const GJS_THANKYOU_BUILDER_ROUTE_IDS = {
  [GJS_THANKYOU_BUILDER_ROUTE_KEYS.update]:
    "/gjs-thankyou-builder/:thankYouPageUuid/update",
};

export const GJS_THANKYOU_BUILDER_ROUTE_GENERATORS = {
  [GJS_THANKYOU_BUILDER_ROUTE_KEYS.update]: ({
    thankYouPageUuid,
    templateUuid,
  }) => {
    const base = `/gjs-thankyou-builder/${thankYouPageUuid}/update`;
    return templateUuid ? `${base}?template=${templateUuid}` : base;
  },
};

export const TP_ACTION_KEYS = {
  listener_added: "tp-listener-added",
  start_init: "tp-start-init",
  save: "tp-save",
  save_draft: "tp-save-draft",
  publish: "tp-publish",
  auto_save: "tp-auto-save",
  notify: "tp-notify",
  exit_builder: "tp-exit-builder",
  exit_builder_legacy: "tp-exit-builder-legacy",
  offering_card_select_open: "offering-card-select-open", // page builder asks CT to open the offering picker modal
  offering_card_select_save: "offering-card-select-save", // CT posts the picked offering back to the page builder
};

export const THANKYOU_BUILDER_URL = `${page_builder_origin}/thankyou`;

export const THANKYOU_APIS = {
  get_thankyou_detail: (uuid) => `marketing/thankyou/page/details/${uuid}`,
  update_thankyou: (uuid) => `marketing/thankyou/page/update/${uuid}`,
  publish_thankyou: (uuid) => `marketing/thankyou/page/publish/${uuid}`,
};
// Unified with thank_you_pages_apis — prefer thank_you_pages_apis elsewhere
export { thank_you_pages_apis as THANK_YOU_PAGES_APIS } from "./ThankYouPages.api";

export const THANKYOU_BUILDER_NOTIFY_MESSAGES = {
  saving: "Saving...",
  saved: "Saved!",
  publishing: "Publishing...",
  published: "Published!",
};
export const THANKYOU_INIT_RETRY_DELAY_MS = 500;
export const THANKYOU_BUILDER_MAX_INIT_ATTEMPTS = 20;
export const THANKYOU_UPGRADE_MODAL_COPY = {
  message: "Upgrade plan to publish your page!",
  description:
    "Create customised thank you pages using Exly\u2019s page builder tool",
  btn_text: "Upgrade plan",
};
